import { combineReducers } from 'redux';
import User from './user';

const RootReducer = combineReducers({ User });

export default RootReducer;